import React, { Component } from 'react'
import Link from 'gatsby-link'
import { PrimaryH3, SecondaryP, ColorOverlay } from './styled-components.js'

export default class TwoImageBlock extends Component {
  constructor() {
    super()
    this.state = {
      leftHoverState: false,
      rightHoverState: false,
    }
  }

  leftHover = () => {
    this.setState({ leftHoverState: true })
  }

  leftUnhover = () => {
    this.setState({ leftHoverState: false })
  }

  rightHover = () => {
    this.setState({ rightHoverState: true })
  }

  rightUnhover = () => {
    this.setState({ rightHoverState: false })
  }

  render() {
    const { component } = this.props
    !component.primaryColor && (component.primaryColor = '#000')
    !component.secondaryColor && (component.secondaryColor = '#8f8f8f')
    const leftTextColor = this.state.leftHoverState
      ? component.primaryColor
      : component.secondaryColor
    const leftOverLayColor = this.state.leftHoverState
      ? component.leftImageOverlayColor
      : null
    const rightTextColor = this.state.rightHoverState
      ? component.primaryColor
      : component.secondaryColor
    const rightOverLayColor = this.state.rightHoverState
      ? component.rightImageOverlayColor
      : null

    const LeftFigCaption = () => (
      <figcaption className="text-container">
        {component.leftCaptionTitle && (
          <PrimaryH3 primaryTextColor={component.primaryColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.leftCaptionTitle,
              }}
            />
          </PrimaryH3>
        )}
        {component.leftCaptionCopy && (
          <SecondaryP secondaryTextColor={leftTextColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.leftCaptionCopy.leftCaptionCopy,
              }}
            />
          </SecondaryP>
        )}
      </figcaption>
    )

    const RightFigCaption = () => (
      <figcaption className="text-container">
        {component.rightCaptionTitle && (
          <PrimaryH3 primaryTextColor={component.primaryColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.rightCaptionTitle,
              }}
            />
          </PrimaryH3>
        )}
        {component.rightCaptionCopy && (
          <SecondaryP secondaryTextColor={rightTextColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.rightCaptionCopy.rightCaptionCopy,
              }}
            />
          </SecondaryP>
        )}
      </figcaption>
    )

    const SpanLeftTitle = () => (
      <span
        onMouseEnter={this.leftHover}
        onMouseLeave={this.leftUnhover}
        dangerouslySetInnerHTML={{
          __html: component.leftCaptionTitle,
        }}
      />
    )

    const SpanLeftCopy = () => (
      <span
        onMouseEnter={this.leftHover}
        onMouseLeave={this.leftUnhover}
        dangerouslySetInnerHTML={{
          __html: component.leftCaptionCopy.leftCaptionCopy,
        }}
      />
    )

    const SpanRightTitle = () => (
      <span
        onMouseEnter={this.rightHover}
        onMouseLeave={this.rightUnhover}
        dangerouslySetInnerHTML={{
          __html: component.rightCaptionTitle,
        }}
      />
    )

    const SpanRightCopy = () => (
      <span
        onMouseEnter={this.rightHover}
        onMouseLeave={this.rightUnhover}
        dangerouslySetInnerHTML={{
          __html: component.rightCaptionCopy.rightCaptionCopy,
        }}
      />
    )

    return (
      <section className="two-image-block">
        <div className="grid-row">
          <div className={`col-6-12 component margin-${component.marginBelow}`}>
            <figure>
              <div className="image-container">
                <div className="image-content left">
                  <img src={`${component.leftImage.file.url}`} />
                </div>

                {component.leftImageExternalLink && (
                  <a href={component.leftImageExternalLink} target="_blank">
                    <ColorOverlay
                      onMouseEnter={this.leftHover}
                      onMouseLeave={this.leftUnhover}
                      hoverColor={leftOverLayColor}
                    />
                  </a>
                )}

                {component.leftImageCaseStudyReference && (
                  <Link
                    to={`/case-study/${
                      component.leftImageCaseStudyReference.slug
                    }`}
                  >
                    <ColorOverlay
                      onMouseEnter={this.leftHover}
                      onMouseLeave={this.leftUnhover}
                      hoverColor={leftOverLayColor}
                    />
                  </Link>
                )}
              </div>

              {component.leftImageExternalLink && (
                <figcaption className="text-container">
                  {component.leftCaptionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <a href={component.leftImageExternalLink} target="_blank">
                        <SpanLeftTitle />
                      </a>
                    </PrimaryH3>
                  )}
                  {component.leftCaptionCopy && (
                    <SecondaryP secondaryTextColor={leftTextColor}>
                      <a href={component.leftImageExternalLink} target="_blank">
                        <SpanLeftCopy />
                      </a>
                    </SecondaryP>
                  )}
                </figcaption>
              )}

              {component.leftImageCaseStudyReference && (
                <figcaption className="text-container">
                  {component.leftCaptionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <Link
                        to={`/case-study/${
                          component.leftImageCaseStudyReference.slug
                        }`}
                      >
                        <SpanLeftTitle />
                      </Link>
                    </PrimaryH3>
                  )}
                  {component.leftCaptionCopy && (
                    <SecondaryP secondaryTextColor={leftTextColor}>
                      <Link
                        to={`/case-study/${
                          component.leftImageCaseStudyReference.slug
                        }`}
                      >
                        <SpanLeftCopy />
                      </Link>
                    </SecondaryP>
                  )}
                </figcaption>
              )}

              {!component.leftImageExternalLink &&
                !component.leftImageCaseStudyReference &&
                (component.leftCaptionTitle || component.leftCaptionCopy) && (
                  <LeftFigCaption />
                )}
            </figure>
          </div>

          <div className={`col-6-12 component margin-${component.marginBelow}`}>
            <figure>
              <div className="image-container">
                <div className="image-content right">
                  <img src={`${component.rightImage.file.url}`} />
                </div>

                {component.rightImageExternalLink && (
                  <a href={component.rightImageExternalLink} target="_blank">
                    <ColorOverlay
                      onMouseEnter={this.rightHover}
                      onMouseLeave={this.rightUnhover}
                      hoverColor={rightOverLayColor}
                    />
                  </a>
                )}

                {component.rightImageCaseStudyReference && (
                  <Link
                    to={`/case-study/${
                      component.rightImageCaseStudyReference.slug
                    }`}
                  >
                    <ColorOverlay
                      onMouseEnter={this.rightHover}
                      onMouseLeave={this.rightUnhover}
                      hoverColor={rightOverLayColor}
                    />
                  </Link>
                )}
              </div>

              {component.rightImageExternalLink && (
                <figcaption className="text-container">
                  {component.rightCaptionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <a
                        href={component.rightImageExternalLink}
                        target="_blank"
                      >
                        <SpanRightTitle />
                      </a>
                    </PrimaryH3>
                  )}
                  {component.rightCaptionCopy && (
                    <SecondaryP secondaryTextColor={rightTextColor}>
                      <a
                        href={component.rightImageExternalLink}
                        target="_blank"
                      >
                        <SpanRightCopy />
                      </a>
                    </SecondaryP>
                  )}
                </figcaption>
              )}

              {component.rightImageCaseStudyReference && (
                <figcaption className="text-container">
                  {component.rightCaptionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <Link
                        to={`/case-study/${
                          component.rightImageCaseStudyReference.slug
                        }`}
                      >
                        <SpanRightTitle />
                      </Link>
                    </PrimaryH3>
                  )}
                  {component.rightCaptionCopy && (
                    <SecondaryP secondaryTextColor={rightTextColor}>
                      <Link
                        to={`/case-study/${
                          component.rightImageCaseStudyReference.slug
                        }`}
                      >
                        <SpanRightCopy />
                      </Link>
                    </SecondaryP>
                  )}
                </figcaption>
              )}

              {!component.rightImageExternalLink &&
                !component.rightImageCaseStudyReference &&
                (component.rightCaptionTitle || component.rightCaptionCopy) && (
                  <RightFigCaption />
                )}
            </figure>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/two-image-block.js